import { Node } from 'tiptap'
import InteractiveMediaLink from '@/components/tiptap/extensions/InteractiveMediaLink.vue'

export default class InteractiveMediaLinkNode extends Node {
    get name() {
        return 'interactive_media_link_node'
    }

    get schema() {
        return {
            attrs: {
                id: {
                    default: null
                },
                dam_id: {
                    default: null
                },
                type: {
                    default: null
                },
                title: {
                    default: null
                },
                media_type: {
                    default: 'pdf'
                }
            },
            group: 'inline',
            selectable: true,
            isolating: true,
            inline: true,
            draggable: true,
            parseDOM: [{
                tag: 'interactive-media-link',
                getAttrs: dom => ({
                    id: dom.getAttribute('id'),
                    dam_id: dom.getAttribute('dam_id'),
                    type: dom.getAttribute('type'),
                    title: dom.getAttribute('title'),
                    media_type: dom.getAttribute('media_type')
                }),
            }],
            toDOM: node => ['interactive-media-link', {
                id: (node.attrs && node.attrs.id) ? node.attrs.id : null,
                dam_id: (node.attrs && node.attrs.dam_id) ? node.attrs.dam_id : null,
                type: (node.attrs && node.attrs.type) ? node.attrs.type : null,
                title: (node.attrs && node.attrs.title) ? node.attrs.title : null,
                media_type: (node.attrs && node.attrs.media_type) ? node.attrs.media_type : null
            }],
        }
    }

    commands({ type }) {
        return (attrs) => (state, dispatch) => {
            dispatch(state.tr.replaceSelectionWith(
                type.create({
                    'id': (attrs) ? attrs.id : null,
                    'dam_id': (attrs) ? attrs.dam_id : null,
                    'type': (attrs) ? attrs.type : null,
                    'title': (attrs) ? attrs.title : null,
                    'media_type': (attrs) ? attrs.media_type : null
                }))
            )
        }
    }

    get view() {
        return InteractiveMediaLink
    }
}
